// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"e3472c81","24":"a7fb35d3","212":"094c7f16","220":"61c07235","232":"373329a4","368":"430ab13d","496":"2d39cc49","592":"f6bd750d","616":"e3527100","644":"4e7a7bec","696":"12e295ba","788":"b6703eb3","808":"0994a653","820":"b18e5e47","856":"2473204d"}[chunkId] + ".chunk.js";
};